import { CashbackLandingPageResources } from "@/src/cashback/LandingPage/CashbackLandingPage.Resources";
import { CashbackLandingPageResourcesEn } from "@/src/cashback/LandingPage/CashbackLandingPage.Resources.En";
import CashbackTopSection from "@/src/cashback/LandingPage/CashbackTopSection";
import { languageSelector } from "@/src/contexts/UserAuthenticationContext";
import PanelSection from "@/src/shared/panel-section";
import { whatIsCashbackPanelId } from "@Constants/PortalConstants";

export function LpTopComponentVersionA({isVariant}:{isVariant?:boolean}) {
    const ME_VERISON = isVariant ?"A":undefined ;

    const resources = languageSelector(CashbackLandingPageResources, CashbackLandingPageResourcesEn);

    return (
        <PanelSection
            telemetryCustom={ {
                eventName: "cshbck-TopSection",
                actionType: "View",
                param1: ME_VERISON,
            }}
            initialInView
        >
            <CashbackTopSection
                resources={resources.topSection}
                scrollToId={whatIsCashbackPanelId}
                version={ME_VERISON}
            />
        </PanelSection>
    );
}
